module.exports = __webpack_public_path__ + "img/ic_qrcode_linkin.873ec1b.webp";